import AnimatedSection from '../common/AnimatedSection'
import { aboutMissionIconMap } from '../icons/AboutMissionIcons'
import { aboutMissionSection } from '../../data/aboutPageData'

function AboutMissionSection() {
  const { label, titleLine1, titleAccent, description, backgroundImage, items } = aboutMissionSection

  return (
    <AnimatedSection className="about-mission-section" id="our-mission">
      <div
        className="about-mission-bg"
        style={{ backgroundImage: `url(${backgroundImage})` }}
        aria-hidden="true"
      />
      <span className="about-mission-dots about-mission-dots--left" aria-hidden="true" />
      <span className="about-mission-dots about-mission-dots--right" aria-hidden="true" />

      <div className="container corp-container about-mission-inner">
        <header className="about-mission-header">
        <div className="about-vision-label">
              <span className="about-vision-label-line" aria-hidden="true" />
              <span>{label}</span>
            </div>
   
          <h2 className="about-mission-title">
            {titleLine1}
            <span>{titleAccent}</span>
          </h2>
          <span className="about-mission-accent" aria-hidden="true" />
          <p className="about-mission-lead">{description}</p>
        </header>

        <div className="about-mission-grid" role="list">
          {items.map((item) => {
            const Icon = aboutMissionIconMap[item.icon]

            return (
              <article className="about-mission-card" key={item.id} role="listitem">
                <span className="about-mission-card-bar" aria-hidden="true" />
                <div className="about-mission-card-body">
                  <span className="about-mission-card-icon">
                    <Icon />
                  </span>
                  <div className="about-mission-card-copy">
                    <h3>{item.title}</h3>
                    <span className="about-mission-card-divider" aria-hidden="true" />
                    <p>{item.text}</p>
                  </div>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AboutMissionSection
